import { CheckCircle2, Circle, Clock, XCircle, AlertTriangle, Lock, FileCheck, IndianRupee } from 'lucide-react';

/**
 * Canonical status labels + colours for tasks, commitments, milestones,
 * projects. Keeps status vocabulary consistent across screens.
 *
 * Usage:
 *   <StatusChip status="in_progress" />
 *   <StatusChip status="done" size="sm" />
 *   <StatusDot status="pending" />
 */

const CATALOG = {
  pending:     { label: 'Pending',     cls: 'status-pending',     Icon: Circle },
  in_progress: { label: 'In progress', cls: 'status-in-progress', Icon: Clock },
  done:        { label: 'Done',        cls: 'status-done',        Icon: CheckCircle2 },
  cancelled:   { label: 'Cancelled',   cls: 'status-cancelled',   Icon: XCircle },
  overdue:     { label: 'Overdue',     cls: 'status-overdue',     Icon: AlertTriangle },
  blocked:     { label: 'Blocked',     cls: 'status-blocked',     Icon: Lock },
  invoiced:    { label: 'Invoiced',    cls: 'status-invoiced',    Icon: FileCheck },
  paid:        { label: 'Paid',        cls: 'status-paid',        Icon: IndianRupee },
  open:        { label: 'Open',        cls: 'status-in-progress', Icon: Clock },
};

function normalize(status) {
  if (!status) return 'pending';
  const key = String(status).toLowerCase().replace(/\s+|-/g, '_');
  return CATALOG[key] ? key : 'pending';
}

export function statusMeta(status) {
  const key = normalize(status);
  return { key, ...CATALOG[key] };
}

export function StatusChip({ status, label, size = 'md', showIcon = true, className = '', ...rest }) {
  const meta = statusMeta(status);
  const iconPx = size === 'sm' ? 10 : 12;
  const paddingCls = size === 'sm' ? 'px-1.5 py-0.5 text-[10.5px]' : '';
  return (
    <span
      className={`chip ${meta.cls} ${paddingCls} ${className}`}
      data-testid={`status-chip-${meta.key}`}
      {...rest}
    >
      {showIcon && <meta.Icon size={iconPx} />}
      {label || meta.label}
    </span>
  );
}

export function StatusDot({ status, className = '' }) {
  const meta = statusMeta(status);
  return (
    <span
      className={`status-dot ${meta.cls} ${className}`}
      data-testid={`status-dot-${meta.key}`}
      aria-label={meta.label}
    />
  );
}
